export default {
  lstTab: {
    overview: 'Giá',
    orderStatistic: 'Đặt lệnh',
    foreign: 'Nước ngoài',
    proprietary: 'Tự Doanh',
    statisticByInvestor: 'Phân loại nhà đầu tư',
  },

  rateList: {
    FromDate: '01/01/2019',
    ToDate: '01/03/2019',
  },

  lstTitleDate: {
    from: 'Từ',
    to: 'Đến',
  },

  defaultRateFrom: 'Từ Ngày',
  defaultRateTo: 'Đến Ngày',

  priceDataTableOverview: {
    DATE: 'NGÀY',
    LAST: 'GIÁ',
    CHANGE: 'THAY ĐỔI',
    PERCENT_PRICE_CHANGE: '% THAY ĐỔI',
    OPEN: 'MỞ',
    HIGH: 'CAO',
    LOW: 'THẤP',
    OPEN_INDEX: 'MỞ',
    HIGH_INDEX: 'CAO',
    LOW_INDEX: 'THẤP',
    AVERAGE_PRICE: 'GIÁ TB',
    MATCHED_VOLUME: 'KL<br> KHỚP', // have space after <br>
    MATCHED_VALUE: 'GT<br> KHỚP', // have space after <br>
    PUT_THROUGH_VOL: 'K.L<br> THỎA THUẬN', // have space after <br>
    PUT_THROUGH_VALUE: 'G.T<br> THỎA THUẬN', // have space after <br>
    TOTAL_VOL: 'TỔNG KHỐI LƯỢNG',
    TOTAL_VALUE: 'TỔNG GIÁ TRỊ',
  },

  priceDataTableOrderStatistic: {
    DATE: 'NGÀY',
    //LAST : 'ClosePriceAdjusted' ,
    LAST: 'GIÁ',
    CHANGE: 'THAY ĐỔI',
    PERCENT_PRICE_CHANGE: '% THAY ĐỔI',
    NR_OF_BUY_ORDER: 'SỐ<br> LỆNH MUA', // have space after <br>
    BUY_VOL: 'KL<br> ĐẶT MUA',
    VOLUMN_BUY_ORDER: 'KLTB<br> 1 LỆNH MUA',
    NR_OF_SELL_ORDER: 'SỐ<br> LỆNH BÁN', // have space after <br>
    SELL_VOL: 'KL<br> ĐẶT BÁN',
    VOLUMN_SELL_ORDER: 'KLTB<br> 1 LỆNH BÁN',
    NET_VOL: 'KL<br> MUA-BÁN',
  },

  priceDataTableForeign: {
    DATE: 'NGÀY',
    //LAST : 'ClosePriceAdjusted' ,
    LAST: 'GIÁ',
    CHANGE: 'THAY ĐỔI',
    PERCENT_PRICE_CHANGE: '% THAY ĐỔI',
    BUY_ORDER_VOL: 'TỔNG KL<br> MUA', // have space after <br>
    BUY_ORDER_VALUE: 'TỔNG GT<br> MUA', // have space after <br>
    SELL_ORDER_VOL: 'TỔNG KL<br> BÁN ', // have space after <br>
    SELL_ORDER_VALUE: 'TỔNG GT<br> BÁN', // have space after <br>
    NET_VOLUME: 'TỔNG KL<br> RÒNG',
    NET_VALUE: 'TỔNG GT<br> RÒNG',
    OWNED_RATIO: '%SHNN',
    FOREIGN_ROOM: 'Room Còn lại',

    BUY_VOL_MATCHED: 'KL Mua  <br> Khớp lệnh',
    BUY_VALUE_MATCHED: 'GT Mua <br> Khớp lệnh',
    SELL_VOL_MATCHED: 'KL Bán <br> Khớp lệnh',
    SELL_VALUE_MATCHED: 'GT Bán <br> Khớp lệnh',
    BUY_VOL_DEAL: 'KL Mua <br> Thỏa thuận',
    BUY_VALUE_DEAL: 'GT Mua <br> Thỏa thuận',
    SELL_VOL_DEAL: 'KL Bán <br> Thỏa thuận',
    SELL_VALUE_DEAL: 'GT Bán <br> Thỏa thuận',
    NET_MATCH_VOL: 'KL Khớp lệnh <br> Ròng',
    NET_MATCH_VALUE: 'GT Khớp lệnh <br> Ròng',
    NET_DEAL_VOL: 'KL Thỏa thuận <br> Ròng',
    NET_DEAL_VALUE: 'GT Thỏa thuận <br> Ròng',
  },

  priceDataTableProprietary: {
    DATE: 'NGÀY',
    //LAST : 'ClosePriceAdjusted' ,
    LAST: 'GIÁ',
    CHANGE: 'THAY ĐỔI',
    PERCENT_PRICE_CHANGE: '% THAY ĐỔI',
    BUY_VOL: 'TỔNG KL MUA ',
    BUY_VALUE: 'TỔNG GT MUA',
    SELL_VOL: 'TỔNG KL BÁN',
    SELL_VALUE: 'TỔNG GT BÁN',
    NET_VOL: 'TỔNG KL RÒNG',
    NET_VALUE: 'TỔNG GT RÒNG',

    BUY_VOL_MATCHED: 'KL Mua  <br> Khớp lệnh',
    BUY_VALUE_MATCHED: 'GT Mua <br> Khớp lệnh',
    SELL_VOL_MATCHED: 'KL Bán <br> Khớp lệnh',
    SELL_VALUE_MATCHED: 'GT Bán <br> Khớp lệnh',
    BUY_VOL_DEAL: 'KL Mua <br> Thỏa thuận',
    BUY_VALUE_DEAL: 'GT Mua <br> Thỏa thuận',
    SELL_VOL_DEAL: 'KL Bán <br> Thỏa thuận',
    SELL_VALUE_DEAL: 'GT Bán <br> Thỏa thuận',
    NET_MATCH_VOL: 'KL Khớp lệnh <br> Ròng',
    NET_MATCH_VALUE: 'GT Khớp lệnh <br> Ròng',
    NET_DEAL_VOL: 'KL Thỏa thuận <br> Ròng',
    NET_DEAL_VALUE: 'GT Thỏa thuận <br> Ròng',
  },

  priceDataTableStatisticByInvestor: {
    DATE: 'NGÀY',
    //LAST : 'ClosePriceAdjusted' ,
    LAST: 'GIÁ',
    CHANGE: 'THAY ĐỔI',
    PERCENT_PRICE_CHANGE: '% THAY ĐỔI',
    NET_INDIVIDUAL_VOLUME: 'KL Cá Nhân <br/> Ròng',
    NET_INDIVIDUAL_VALUE: 'GT Cá Nhân <br/> Ròng',
    NET_INSTITUTION_VOLUME: 'KL Tổ chức <br/> Ròng',
    NET_INSTITUTION_VALUE: 'GT Tổ chức <br/> Ròng',
    NET_PROPRIETARY_VOLUME: 'KL Tự doanh <br/> Ròng',
    NET_PROPRIETARY_VALUE: 'GT Tự doanh <br/> Ròng',
    NET_FOREIGN_VOLUME: 'KL Nước Ngoài <br/> Ròng',
    NET_FOREIGN_VALUE: 'GT Nước Ngoài <br/> Ròng',

    NET_INDIVIDUAL_MATCH_VOLUME: 'KL Cá Nhân <br/> Khớp Ròng',
    NET_INDIVIDUAL_MATCH_VALUE: 'GT Cá Nhân <br/> Khớp Ròng',
    NET_INSTITUTION_MATCH_VOLUME: 'KL Tổ chức <br/> Khớp Ròng',
    NET_INSTITUTION_MATCH_VALUE: 'GT Tổ chức <br/> Khớp Ròng',
    NET_PROPRIETARY_MATCH_VOLUME: 'KL Tự doanh <br/> Khớp Ròng',
    NET_PROPRIETARY_MATCH_VALUE: 'GT Tự doanh <br/> Khớp Ròng',
    NET_FOREIGN_MATCH_VOLUME: 'KL Nước Ngoài <br/> Khớp Ròng',
    NET_FOREIGN_MATCH_VALUE: 'GT Nước Ngoài <br/> Khớp Ròng',
  },

  listTimeRangeByKey: {
    Daily: 'THEO NGÀY',
    Weekly: 'THEO TUẦN',
    Monthly: 'THEO THÁNG',
    Yearly: 'THEO NĂM',
  },

  indexInfo: {
    Open: 'O',
    Hight: 'H',
    Low: 'L',
    Bid: 'BID',
    Ask: 'ASK',
  },

  footerText1:
    'Giá: x 1,000. Khối Lượng: x 1,000. Giá trị: x 1,000,000. Ngày Thực Hiện được đánh dấu sao',
  footerText2: 'Giá: x 1,000. Khối Lượng: x 1,000. Giá Trị: x 1,000,000',
  footerTextDerivative: ' Giá trị: x 1,000,000.',
  // proprietaryNotice: {
  //   title: 'Thông báo',
  //   content:
  //     'Từ ngày 1/3/2022, dữ liệu Tự doanh được thay thế bằng dữ liệu Tổ chức trong nước <br/> (đã bao gồm dữ liệu Tự doanh).',
  // },
  // statInvestorNotice: {
  //   title: 'Thông báo',
  //   content:
  //     'Từ ngày 1/3/2022, dữ liệu Tự doanh được cộng dồn vào dữ liệu Tổ chức trong nước.',
  // },
};
